import { useTranslation } from "react-i18next";
import { BackgroundRippleEffect } from "@/components/ui/background-ripple-effect";

export function SentryErrorFallback() {
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-gray-50 dark:bg-black">
      <BackgroundRippleEffect />
      <div className="relative z-10 flex flex-col items-center justify-center gap-8 px-4 text-center">
        <div className="flex flex-col gap-4">
          <h1 className="text-8xl font-bold text-red-600 dark:text-red-500 md:text-9xl">
            {t("errors.crash.title")}
          </h1>
          <h2 className="text-3xl font-semibold text-gray-900 dark:text-white md:text-4xl lg:text-5xl">
            {t("errors.crash.heading")}
          </h2>
        </div>

        <p className="max-w-xl text-lg text-gray-600 dark:text-gray-400 md:text-xl">
          {t("errors.crash.description")}
        </p>

        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 rounded-lg bg-gray-900 px-8 py-4 text-lg font-medium text-white transition-all hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-white dark:text-black dark:hover:bg-gray-100 dark:focus:ring-gray-700"
        >
          {t("common.actions.reload")}
        </button>
      </div>
    </div>
  );
}
